export const blockIconsActivitiesSportsMotorsportsNew = (
	<span className='material-symbols-outlined'>sports_motorsports</span>
);
